import { normalizeDisableFeatureRewrite } from 'lib/route-helpers/disable-feature';
import { Plugin } from '..';

class DisableFeaturePlugin implements Plugin {
  exec(path: string) {
    // Remove storeId rewrite segment from the path
    return normalizeDisableFeatureRewrite(path);
  }
}

export const disableFeaturePlugin = new DisableFeaturePlugin();
